<template>
  <component :style="{fontSize: iconSize, color: iconColor}"
             :color="iconColor"
             :class="['icons', 'base-icons', `icons-${iconName}`]"
             v-bind="svgAttrs"
             :is="iconName"></component>
</template>

<script>
import Delete from '@/assets/icons/wc/delete.vue';
import Down from '@/assets/icons/wc/down.svg';

export default {
  name: 'BaseIcon',
  components: {delete: Delete, down: Down},
  props: {
    iconColor: {
      type: String,
      default: '',
    },
    iconSize: {
      type: String,
      default: '',
    },
    iconName: {
      type: String,
      default: '',
    },
  },
  computed: {
    svgAttrs() {
      switch(this.iconName) {
        case 'down': return {
          width: '19', height: '19', viewBox: "-5 -7 19 19"
        };
        
      }
      return {};
    }
  }
};
</script>
<style>
  .base-icons {
    font-size: 24px;
  }
</style>
